import React, { useEffect, useState } from "react";
import { updateBankDetails } from "../../../apis/customers";
import { successAlert } from "../../../style/scss/utils/Alerts";

const BankDetails = ({ customerData }) => {
  const user = customerData?.allData;
  const userData = JSON.parse(sessionStorage.getItem("info"));

  const [formData, setFormData] = useState({
    bankName: "",
    bankAccountNo: "",
    ifscCode: "",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        bankName: user.bankName || "",
        bankAccountNo: user.bankAccountNo || "",
        ifscCode: user.ifscCode || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const res = await updateBankDetails({
        userId: user.id,
        ...formData,
      });
      if (res.data.status === true) {
        successAlert("Success", "Details Successfully Updated");
      }
    } catch (error) {
      console.error("Update failed:", error);
      successAlert("Success", "Details Successfully Updated");
    }
  };
  const isBankDataFilled =
    !!user?.bankName || !!user?.bankAccountNo || !!user?.ifscCode;

  // Show button for financer always, for others only if data is not filled
  const showSubmitButton = userData?.type === "financer" || !isBankDataFilled;

  // Disable inputs if not allowed
  const isEditable = showSubmitButton;
  return (
    <div className="modal fade" id="show_bank">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Bank Details</h3>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body theme_new_color">
            {user && (
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Bank Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bankName"
                    value={formData.bankName}
                    onChange={handleChange}
                    disabled={!isEditable}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Bank Account Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="bankAccountNo"
                    value={formData.bankAccountNo}
                    onChange={handleChange}
                    disabled={!isEditable}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">IFSC Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ifscCode"
                    value={formData.ifscCode}
                    onChange={handleChange}
                    disabled={!isEditable}
                  />
                </div>
                {showSubmitButton && (
                  <div className="col-md-12 text-end">
                    <button className="btn btn-primary" onClick={handleSubmit}>
                      {isBankDataFilled ? "Update" : "Submit"}
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankDetails;
